// Libs
import React, { useState } from "react";
import PropTypes from "prop-types";

// Context
import SidebarDisplayStateContext from "contexts/sidebar/DisplayState";

export default function SidebarDisplayStateProvider({ children }) {
  const sidebarDisplayState = useState(false);

  return (
    <SidebarDisplayStateContext.Provider value={sidebarDisplayState}>
      {children}
    </SidebarDisplayStateContext.Provider>
  );
}

SidebarDisplayStateProvider.propTypes = {
  children: PropTypes.node
};
